import name from 'forms/shared/validators/models/name/name';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { hasYesOrNo } from 'models/validate';
import { ForeignBusinessAdviceItemModel } from '../types';

export const foreignBusinessAdviceItemValidator: ValidateJSModel<ForeignBusinessAdviceItemModel> = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqNameModelValidator } };
    }

    return { presence: true, model: { validator: name } };
  },

  Description: (value, attributes, attributeName, options) => {
    return { hasValue: true };
  },

  Organization: { hasValue: true },

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  ReceivedCompensation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  Compensation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.ReceivedCompensation?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },

  Role: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true };
    }

    return {};
  },

};
